import loadable from '@loadable/component';
import expertGuideQuery from './query.graphql';

const ExpertGuide = loadable(() =>
  import(/* webpackChunkName: "expert" */ './guide')
);

ExpertGuide.graphQL = expertGuideQuery;

ExpertGuide.variables = ({ slug }) => ({
  slug,
});

export default ExpertGuide;
